export interface CmsProtectionUpsellPanel {
  averageProtectedRepairCost: string;
  averageUnprotectedRepairCost: string;
  protectionUpsellTitle: string;
}
